import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=72508e9e"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"
import style0 from "./tree.vue?vue&type=style&index=0&id=72508e9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports